module.exports = __webpack_public_path__ + "img/games.1f6fccdd.webp";